<template>
  <div class="px-9 sm:px-14 md:px-32 xl:px-56 py-9 md:py-20 flex-col-grow">
    <div class="bg-image brand-img search-vouchers-brand"></div>
    <div class="flex-col-grow justify-center">
      <transition name="fade" @after-leave="afterTransition">
        <div
          v-if="show"
          class="flex flex-col lg:flex-row-reverse items-center justify-around"
        >
          <div
            class="mt-6 mb-20 bg-image sm:hidden lg:block lg:m-0 brand-img-alt"
          ></div>
          <div class="px-5 sm:py-10 w-full max-w-lg">
            <div class="pb-5 sm:pb-0 sm:flex">
              <div class="sm:flex-grow">
                <h1
                  class="
                    font-medium
                    text-3xl
                    sm:text-2xl
                    md:text-4xl
                    text-base-color-alt
                  "
                >
                  Pago Express
                </h1>
                <p
                  class="
                    my-6
                    sm:mt-3
                    sm:mb-4
                    md:mt-5
                    md:mb-8
                    w-full
                    max-w-xs
                    leading-relaxed
                    text-gray-3
                  "
                >
                  Ingresa con tu rut y selecciona lo que <br />
                  deseas pagar. Simple, fácil, rápido.
                </p>
              </div>
              <div class="hidden sm:block lg:hidden">
                <div class="bg-image brand-img-alt"></div>
              </div>
            </div>
            <SearchForm @pay="onPay" />
          </div>
        </div>
      </transition>
    </div>
  </div>
  <div class="hidden w-full h-16 bg-gray brand-banner"></div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SearchForm from "@/components/SearchForm.vue";
import { inject } from "@vue/runtime-core";
import {
  RequestStatus,
  VouchersService,
  VOUCHER_SERVICE,
} from "@/services/vouchers-service";

@Options({
  components: {
    SearchForm,
  },
})
export default class SearchVouchersView extends Vue {
  show = true;
  private voucherService!: VouchersService;
  private nextRoute!: string;
  private transitionLeaved = false;

  beforeCreate(): void {
    const voucherService = inject<VouchersService>(VOUCHER_SERVICE);

    if (!voucherService) {
      console.error("No voucher service injected");
      this.$router.push({ name: "error" });
    }

    this.voucherService = voucherService as VouchersService;
  }

  afterTransition(): void {
    this.pushRoute(null);
  }

  onPay(event: string): void {
    this.show = false;
    this.voucherService
      .getVouchers(event)
      .then((status: RequestStatus) => {
        switch (status) {
          case RequestStatus.OK:
            this.pushRoute("vouchers");
            break;
          case RequestStatus.NO_VOUCHERS:
            this.pushRoute("up-to-date");
            break;
          case RequestStatus.NO_CREDITOR:
            this.pushRoute("creditor-not-found");
            break;
        }
      })
      .catch(() => {
        this.pushRoute("error");
      });
  }

  private pushRoute(route: string | null) {
    if (route) {
      this.nextRoute = route;
    } else {
      this.transitionLeaved = true;
    }
    if (this.nextRoute && this.transitionLeaved) {
      this.$router.push(this.nextRoute);
    }
  }
}
</script>
